import type { PassengerDTO } from '@/types/dto/agent';
import { type Components } from '@/types/schemas/agent-schema';

type PassengerSpecification =
  Components.Schemas.TurnitOsdmTranslatorApiFeaturesModificationsModelsPassengerSpecification;

// Maps booking passengers into the shape
// `Modifications_FindExchangeOffers` expects. The input is `PassengerDTO`
// rather than search-form passengers on purpose: a modification names
// passengers by their booking `externalReference`, so a passenger without one
// is dropped — the endpoint has no other way to identify them.
export const buildExchangePassengerSpecifications = (
  passengers: ReadonlyArray<PassengerDTO>
): Array<PassengerSpecification> =>
  passengers.flatMap(({ externalReference, type, age }) =>
    externalReference
      ? [
          {
            externalReference,
            type: type || 'PERSON',
            ...(age != null ? { age } : {}),
          },
        ]
      : []
  );
